import ApiConnector from "../connector";

class CounterpartiesActions {
  get = async (params) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.get(`/counterparties/`, { params });
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
  getOne = async (slug) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.get(`/counterparties/${slug}/`);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
  create = async (counterpartie) => {
    const result = {
      value: false,
      error: null,
    };

    let payload = JSON.parse(
      JSON.stringify(counterpartie)
    );

    delete payload.counterparty_contacts

    try {
      const response = await ApiConnector.connector.post(`/counterparties/`, payload);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data;
    }

    return result;
  };
  update = async (counterpartie) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.patch(`/counterparties/${counterpartie.slug}/`, counterpartie);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data;
    }

    return result;
  };
  delete = async (slug) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.delete(`/counterparties/${slug}/`);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
}

export default new CounterpartiesActions();
